export default __webpack_public_path__ + "images/2102955d7adc6c58ce304e52b4d5b30f.png";